export class MercadoriasCategoriasModel {
  id_categoria: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-categorias/mercadorias-categorias.model.ts